import { TableCell, TableRow } from '~/components/tables/common/BaseTable';
import { type Column } from '@tanstack/react-table';
import { useMemo } from 'react';

export function DataTableSkeletons<TData>({ columns }: { columns: Column<TData, unknown>[] }) {
  const skeletonRows = useMemo(() => {
    return Array.from({ length: 15 }).map((_, rowIndex) => (
      <TableRow key={`skeleton-${rowIndex}`}>
        {columns.map((column) => (
          <TableCell key={column.id}>
            {column.columnDef.meta?.skeleton ? column.columnDef.meta.skeleton() : null}
          </TableCell>
        ))}
      </TableRow>
    ));
  }, []);

  return skeletonRows;
}
